import { DotDotDotWidgetStyles } from './DotDotDotWidgetStyles'
import React from 'react'
// import { DotDotDotWidgetProps } from './types/DotDotDotWidgetProps'

export const DotDotDotWidget = (): JSX.Element => {
  return <div className={'DotDotDotWidget ' + DotDotDotWidgetStyles} />
}
